import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreativeCommons, faCreativeCommonsBy } from "@fortawesome/free-brands-svg-icons";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import { ContainerWrapper, FlexLeft, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import Banner from "../Certificates/Components/Banner";

import BannerBig from "../../Images/min-chess.jpg";
import BannerSmall from "../../Images/max-chess.jpg";
import LicenseMD from "./Contents/License.md";




class License extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "License";
    return (
      <div className="App">
        <HelmetTitle title="License" />
        <Layout 
          head={<Navbar />}
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
              <Body name={name} markdownPath={LicenseMD} />
              <CreativeCommons />
            </React.Fragment>
          }
            />
        </div>
        
    );
   }    
}

function CreativeCommons() {
  return (
    <ContainerWrapper className="pt-2">
      <FlexLeft>
        <div className="license__text text-left">
          <p>
            <span><FontAwesomeIcon icon={faCreativeCommons} size="2x" />  </span>
            <span><FontAwesomeIcon icon={faCreativeCommonsBy} size="2x" /></span>
          </p>
          <p>
            <small>
              Except where otherwise <a href="https://creativecommons.org/policies#license" target="_blank" rel="noopener noreferrer">noted</a>, content on this site is licensed under a <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribution 4.0 International (CC BY 4.0)</a>.
            </small>
          </p>
        </div>
      </FlexLeft>
    </ContainerWrapper>
  )
}
export default withRouter(License)



// WEBPACK FOOTER //
// ./src/Pages/Misc/License.js